import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  sumBy,
  noop,
} from 'lodash';

import {
  formatPhoneNumber,
  formatPrice,
  toLongDateFormat,
  // getFullNameOrEmail,
} from 'helpers/utils';
import {
  Divider,
  injectIntl,
  PrintableTable,
  NotificationBadge,
} from 'components';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Activities from './Activities';

const styles = () => ({
  btnActivities: {
    color: '#2e79ff',
  },
  badge: {
    marginLeft: 15,
  },
  badgeSpan: {
    backgroundColor: '#ff602e',
    color: 'white',
  },
});

class InvoicePrint extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    currentUser: PropTypes.shape({}).isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    info: PropTypes.shape({}).isRequired,
    currentActivity: PropTypes.shape({}),
    userLogoImage: PropTypes.string,
    formatMessage: PropTypes.func.isRequired,
    onClickActivity: PropTypes.func,

  };

  static defaultProps = {
    data: [],
    userLogoImage: '',
    onClickActivity: noop,
    currentActivity: {},
  };

  static contextTypes = {
    isFarmer: PropTypes.bool,
    isDistributor: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
  };

  state = {
    showActivities: true,
  };

  getFields = () => {
    const { isDistributor, isRestaurant } = this.context;
    const { formatMessage, info } = this.props;
    const fields = [
      {
        className: 'category',
        colSpan: 2,
        label: formatMessage('Category'),
        name: 'category',
      },
      {
        className: 'highlight',
        colSpan: 3,
        label: formatMessage('IN'),
        name: 'name',
      },
      {
        className: 'highlight',
        colSpan: 3,
        label: formatMessage('ISN'),
        name: 'subname',
      }];
    if (!isDistributor) {
      fields.push({
        colSpan: 3,
        label: formatMessage('Tags'),
        name: 'tags',
        render: data => data.tags.join(', '),
      });
    }
    fields.push(
      {
        colSpan: 2,
        label: formatMessage('Pack-Out'),
        render: data => `${data.count} ${data.uom} ${data.pack}`,
        name: 'uom',
      },
      {
        colSpan: 2,
        label: isRestaurant ? formatMessage('Vendor') : (info.type === 'SO' ? formatMessage('Vendor') : formatMessage('Customer')),
        name: isRestaurant ? 'sourcename' : (info.type === 'SO' ? 'sourcename' : 'customername'),
        render: row => (<span className={row.className}>{isRestaurant ? row.sourcename : (info.type === 'SO' ? row.sourcename : row.customername)}</span>),
      },
      { 
        label: formatMessage('Price'),
        name: 'discounted',
        render: data => (data.discounted ? `$${formatPrice(data.discounted)}` : ''),
      },
      {
        label: formatMessage('Qty'),
        name: 'quantity',
        render: row => (<span className={row.className}>{row.quantity ? `${row.isParent ? `${row.quantity} ${row.diff}` : row.diff}` : '0'}</span>),
      },
      {
        label: formatMessage('Total'),
        name: 'priceTotal',
        render: data => `$${(((data.price * (100 - (data.discount || 0))) / 100) * data.quantity).toFixed(2)}`,
      },
    );
    return fields;
  }

  render() {
    const {
      classes,
      currentUser,
      data,
      info,
      userLogoImage,
      formatMessage,
      currentActivity,
      onClickActivity,
    } = this.props;

    const { isRestaurant, isDistributor, isFarmer, isConsumer } = this.context;
    const { showActivities } = this.state;
    const fields = this.getFields();
    const gross = parseFloat(sumBy(data, item => !item.hide &&
      (item.price * item.quantity))).toFixed(2);
    const isContactInfo = !!info.contact;

    const fromAddress = info.sellerAddress || {};
    const toAddress = info.buyerAddress || {};
    const showAll = true;
    // const editorProfile = get(info, 'editorMember.profile') || {};
    // const fullNameOrEmail = getFullNameOrEmail(currentUser.organizations[0].account);
    const creatorProfile = get(info, 'creatorAccount.profile') || {};
    const creatorBusinessName = creatorProfile.companyName ? creatorProfile.companyName : `${creatorProfile.firstName} ${creatorProfile.lastName}`;
    const buyerProfile = get(info, 'buyer.account.profile') || {};
    const buyerBusinessName = buyerProfile.companyName ? buyerProfile.companyName : `${buyerProfile.firstName} ${buyerProfile.lastName}`;
    const isAggregatedOrder = JSON.parse(info.createdAsDraft || false);

    return (
      <div className="all-invoices-print-preview">
        <h1>{formatMessage('Invoice')} #{info.orderNum}</h1>
        <h4>{formatMessage('Order date')}: {toLongDateFormat(info.deliveryDate)}</h4>
        { (!!info.creatorAccountId && info.creatorAccountId !== info.buyer.accountId && isFarmer) ? (
          <div>
            <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${creatorBusinessName}`}
          </div>
        ) : !info.creatorAccountId && isFarmer && !info.isDraft && (
          <div>
            <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${buyerBusinessName}`}
          </div>
        )}
        { (!!info.creatorAccountId && info.creatorAccountId !== info.buyer.accountId && isDistributor && (info.type !== 'PO' || (info.type === 'PO' && isAggregatedOrder !== true))) ? (
          <div>
            <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${creatorBusinessName}`}
          </div>
        ) : !info.creatorAccountId && isDistributor && info.type !== 'PO' && (
          <div>
            <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${buyerBusinessName}`}
          </div>
        )}
        { (!!info.creatorAccountId && info.creatorAccountId !== info.buyer.accountId && isRestaurant) ? (
          <div>
            <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${creatorBusinessName}`}
          </div>
        ) : !info.creatorAccountId && isRestaurant && (
          <div>
            <span style={{ color: 'red' }}>{formatMessage('Member')}</span>: {`${buyerBusinessName}`}
          </div>
        )}
        <div className="top-panel" style={{ marginTop: 20 }}>
          <div>
            <img
              src={userLogoImage}
              alt=""
            />
          </div>
          <div className="from-to-blocks">
            <div className="from-to-block" style={{maxWidth: '350px'}}>
              <div className="right-gap grey w-20 text-left">
                <b>{formatMessage('To')}:</b>
              </div>
              <div>
                <div>
                  <b>
                    {get(info, 'contact.buyerProfile.companyName') || get(info, 'buyer.account.profile.companyName')}
                  </b>
                </div>
                <div>
                  {
                    !isConsumer ? isContactInfo ? (`${get(info, 'contact.buyerProfile.firstName')} ${get(info, 'contact.buyerProfile.lastName')}`) :
                    (`${get(info, 'buyer.account.profile.firstName')} ${get(info, 'buyer.account.profile.lastName')}}`) : null
                  }
                </div>
                <div>{toAddress.address}</div>
                <div>{toAddress.city}</div>
                <div>{toAddress.state && toAddress.zipcode ? `${toAddress.state || ''} - ${toAddress.zipcode || ''}` : ''}</div>
                <div>{formatMessage('Email')}: {info.buyer.account.email}</div>
                <div>{formatMessage('Phone')}: {formatPhoneNumber(get(info, 'contact.buyerProfile.mobile') || get(info, 'buyer.account.profile.mobile'))}</div>
              </div>
            </div>
            <div className="from-to-block" style={{maxWidth: '350px'}}>
              <div className="right-gap grey">
                <b>{formatMessage('From')}:</b>
              </div>
              <div>
                <div>
                  <b>
                    {get(info, 'contact.sellerProfile.companyName') || get(info, 'seller.account.profile.companyName')}
                  </b>
                </div>
                <div>
                  {
                    isContactInfo ? `${get(info, 'contact.sellerProfile.firstName')} ${get(info, 'contact.sellerProfile.lastName')}` :
                    `${get(info, 'seller.account.profile.firstName')} ${get(info, 'seller.account.profile.lastName')}}`
                  }
                </div>
                <div>
                  {info && info.deliveryType === 2 && (
                    <span>{formatMessage('Pick-Up')}: </span>
                  )}
                  {fromAddress.address}
                </div>
                <div>{fromAddress.city}</div>
                <div>
                  {
                    fromAddress.state && fromAddress.zipcode ? `${fromAddress.state || ''} - ${fromAddress.zipcode || ''}` : ''
                  }
                </div>
                <div>{formatMessage('Email')}: {info.seller.account.email}</div>
                <div className="bottom-gap">
                  {formatMessage('Phone')}: {formatPhoneNumber(
                    get(info, 'contact.sellerProfile.mobile') ||
                      get(info, 'seller.account.profile.mobile'),
                  )}
                </div>
                {get(info, 'seller.account.profile.organicNumber') && (
                  <div className="organic-handler">
                    Organic Number: {get(info, 'seller.account.profile.organicNumber')}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-panel-wrapper pull-right text-right">
            <div className="bottom-panel">
              <div className="payment-subpanel">
                <div>
                  <span>{formatMessage('P.O. NUMBER')}</span>
                  <span>: {info.id}</span>
                </div>
              </div>
              {
                <div>
                  <div>
                    <span>{formatMessage('GROSS TOTAL')}</span>
                    <span>: ${gross}</span>
                  </div>
                  {info.discount > 0 && (
                    <div>
                      <span>{formatMessage('DISCOUNT')}</span>
                      <span>: {info.discount}%</span>
                      <span> -${formatPrice((gross * info.discount) / 100)}</span>
                    </div>
                  )}
                  {info.reduction > 0 && (
                    <div>
                      <span>{formatMessage('DISCOUNT')}:</span>
                      <span> -${formatPrice(info.reduction)}</span>
                    </div>
                  )}
                  {info.credit > 0 && (
                    <div>
                      <span>{formatMessage('CREDIT')}:</span>
                      <span> -${formatPrice(info.credit)}</span>
                    </div>
                  )}
                  <div className="subtotal-wrap">
                    <span>
                      {formatMessage('SUBTOTAL')}
                    </span>
                    <span>
                      : ${formatPrice(gross - ((gross * info.discount) / 100) - ( info.reduction || 0) - (info.credit || 0) )}
                    </span>
                  </div>
                  <div>
                    <span>
                      {formatMessage('TAX')}:
                    </span>
                    <span>
                      ${formatPrice(info.tax)}
                    </span>
                  </div>
                  {
                    info.deliveryFee > 0 ? (
                      <div>
                        <span>{formatMessage('DELIVERY FEE')}</span>
                        <span>: ${formatPrice(info.deliveryFee)}</span>
                      </div>
                    ) : null
                  }
                  <div className="total-due-wrap">
                    <b>
                      <span>{formatMessage('NET DUE')}</span>
                      <span>: ${formatPrice(((gross * (100 - info.discount)) / 100) + info.deliveryFee + info.tax - (info.reduction || 0) - (info.credit || 0) )}</span>
                    </b>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        {(isConsumer || isFarmer) && <div className="note-to-seller"><b>{formatMessage('Code/Note to seller')}:</b> {info.noteToSeller}</div>}
        {!isConsumer && <div className="internal-note"><b>{formatMessage('Internal note')}:</b> {info.type === 'PO' ? info.buyerNote : info.sellerNote}</div>}
        <br />
        <PrintableTable fields={fields} data={data} />
        <Divider />
        <div className="activities-panel">
          {Boolean(get(info, 'orderActivities.length')) && (
            <Fragment>
              <div className="invoice-change-log">
                <span>{formatMessage('INVOICE CHANGE LOG')}</span> <span>{get(info, 'orderActivities.length')}</span>
              </div>
              <Button
                classes={{ root: classes.btnActivities }}
                onClick={() => this.setState({ showActivities: !showActivities })}
                id="activities"
              >
                <span>{formatMessage('INVOICE CHANGE LOG')}</span>
                <NotificationBadge classes={{
                  badge: { badge: classes.badgeSpan },
                  root: { root: classes.badge },
                }}>
                  {get(info, 'orderActivities.length')}
                </NotificationBadge>
              </Button>
              {showActivities &&
                <Activities
                  currentUser={currentUser}
                  order={info}
                  formatMessage={formatMessage}
                  onClick={onClickActivity}
                  currentActivity={currentActivity}
                  showAll={showAll}
                />
              }
            </Fragment>
          )}
        </div>
        <br />
        <div className="break-print" />
      </div>
    );
  }
}

const wrappedInvoicePrint = withStyles(styles)(injectIntl(InvoicePrint));
wrappedInvoicePrint.displayName = 'InvoicePrint';

export default wrappedInvoicePrint;
